import React, { useState } from 'react';
import {
    BookOpen,
    FileText,
    Zap,
} from 'lucide-react';
import { UserGuideSidebar, GuideSection } from '../components/user-guide/UserGuideSidebar';
import { UserGuideContent } from '../components/user-guide/UserGuideContent';

const UserGuidePage: React.FC = () => {
    const [activeSection, setActiveSection] = useState('overview');
    const [expandedSections, setExpandedSections] = useState<string[]>(['core-modules', 'app-notes']);
    const [searchTerm, setSearchTerm] = useState('');

    const guideSections: GuideSection[] = [
        {
            id: 'overview',
            title: 'Getting Started',
            icon: <BookOpen size={18} />,
            subsections: [
                { id: 'overview-intro', title: 'Welcome to Resolve' },
                { id: 'overview-quickstart', title: 'Quick Start' },
            ]
        },
        {
            id: 'app-notes',
            title: 'Application Notes',
            icon: <FileText size={18} />,
            subsections: [
                { id: 'note-fracas', title: 'Effective FRACAS' },
                { id: 'note-8d', title: '8D Best Practices' },
                { id: 'note-lab', title: 'Lab Integration' },
            ]
        },
        {
            id: 'core-modules',
            title: 'App Cards & Features',
            icon: <Zap size={18} />,
            subsections: [
                { id: 'card-fracas', title: 'FRACAS Module' },
                { id: 'card-8d', title: '8D Problem Solving' },
                { id: 'card-lab', title: 'Lab Management' },
                { id: 'card-analytics', title: 'Reliability Analytics' },
                { id: 'card-rca', title: 'RCA Tools' },
            ]
        },
    ];

    const toggleSection = (sectionId: string) => {
        setExpandedSections(prev =>
            prev.includes(sectionId)
                ? prev.filter(id => id !== sectionId)
                : [...prev, sectionId]
        );
    };

    const scrollToSection = (sectionId: string) => {
        setActiveSection(sectionId);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className="min-h-screen flex">
            <UserGuideSidebar
                guideSections={guideSections}
                activeSection={activeSection}
                expandedSections={expandedSections}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                toggleSection={toggleSection}
                scrollToSection={scrollToSection}
            />
            <UserGuideContent />
        </div>
    );
};

export default UserGuidePage;
